module.exports = __webpack_public_path__ + "img/logo.11415c11.png";